

export const buildSaveStepContentFormData = (
    stepContentState
) => {
    // Use activeContentType as fallback if ContentType is not set or doesn't match
    // This ensures the correct files are sent when user switches between Image and Video
    const contentType = stepContentState.ContentType || stepContentState.activeContentType || "";
    const formData = new FormData();

    const descriptionData = {
        en: stepContentState.englishDescriptionContent,
        no: stepContentState.norwegianDescriptionContent,
    };
    formData.append("Description", JSON.stringify(descriptionData));

    // Only send files if there are NEW uploads (not existing files being re-sent)
    if (stepContentState.hasNewFiles) {
        // Determine which files to send based on contentType and which files are actually present
        let files = [];
        if (contentType === "Image" && stepContentState.imageFiles?.length > 0) {
            files = stepContentState.imageFiles;
        } else if (contentType === "Video" && stepContentState.videoFiles?.length > 0) {
            files = stepContentState.videoFiles;
        } else if (stepContentState.imageFiles?.length > 0) {
            // Fallback: if image files exist, use them
            files = stepContentState.imageFiles;
        } else if (stepContentState.videoFiles?.length > 0) {
            // Fallback: if video files exist, use them
            files = stepContentState.videoFiles;
        }
        
        if (files?.length) {
            for (const file of files) {
                formData.append("StepContents", file);
            }
        }
    }

    if (stepContentState.descriptionBgImgFile) {
        formData.append("StepBackgroundImageFile", stepContentState.descriptionBgImgFile);
    }

    return formData;
};

export const createFiles = (responses, fileNames, blobType) => {
    return responses.map((response, index) => {
        const blob = new Blob([response.data], { type: blobType });
        return new File([blob], fileNames[index]);
    });
};

export const showStepSelectionError = (lngsltd) => {
    alert(
        lngsltd["Sorry, you did not select the step, please refresh the page and then select a step and proceed"]
    );
};

